<template>
  <div
    class="footer-container"
    :class="[
      !visible ? 'footer-container-hide' : '',
      canCovered ? 'footer-container-can-covered' : '',
      device.isIPhoneX ? 'footer-x' : ''
    ]"
  >
    <div
      class="footer-item"
      v-for="item in footerOptions"
      :key="item.value"
      :class="item.value === footerActive ? 'footer-item-active' : ''"
      @click="footerHandle(item)"
    >
      <div class="item-icon" :style="{ backgroundImage: item.value === footerActive ?  `url(${item.iconActive})` : `url(${item.icon})` }"></div>
      <div class="item-label">{{ item.label }}</div>
    </div>
    <!-- <template v-for="item in footerOptions">
      <div
        :key="item.value"
        v-show="item.value === footerActive"
        class="footer-item footer-item-active"
        @click="footerHandle(item)"
      >
        <div class="item-icon" :style="{ backgroundImage: `url(${item.iconActive})` }"></div>
        <div class="item-label">{{ item.label }}</div>
      </div>
      <div
        :key="item.value"
        v-show="item.value !== footerActive"
        class="footer-item"
        @click="footerHandle(item)"
      >
        <div class="item-icon" :style="{ backgroundImage: `url(${item.icon})` }"></div>
        <div class="item-label">{{ item.label }}</div>
      </div>
    </template> -->
  </div>
</template>

<script>
/*
  移动端底部组件
*/
export default {
  name: "myFooter",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    footerActive: {
      type: String,
      default: ''
    },
    footerOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    canCovered: { // 可以被覆盖，不会再其他弹窗之上
      type: Boolean,
      default: false
    },
  },
  methods: {
    footerHandle(item) {
      this.$emit('footerMenuChange', item.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 128rem;
  z-index: 2999;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: bottom 0.2s linear;
  box-shadow: 0px 3px 8px 0px rgba(32,37,36,0.1);

  .footer-item{
    height: 128rem;
    overflow: hidden;

    .item-icon{
      display: block;
      width: 48rem;
      height: 48rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-top: 21rem;
    }

    .item-label{
      font-size: 22rem;
      color: #999;
      line-height: 22rem;
      margin-top: 11rem;
      text-align: center;
    }
  }

  .footer-item-active{
    .item-label{
      color: #0FC29A;
    }
  }
}

.footer-container-hide{
  bottom: -128rem;
}

.footer-container-can-covered{
  z-index: 1999;
}

.footer-container.footer-x{
  height: 162rem;
  padding-bottom: 34rem;
}
.footer-container-hide.footer-x{
  bottom: -162rem;
}
</style>